
import { takeUntil } from 'rxjs/operators';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  NgZone,
  HostListener
} from '@angular/core';
import { RecordingService } from '@app/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { concat, differenceBy, uniqBy, map } from 'lodash';
import Bugsnag from '@bugsnag/js';
import { ReactionComponent } from '@app/shared/reaction/reaction.component';
import {
  EventService,
  PlaylistService,
  UsersService,
  HelperService,
  UtilService,
  ProfileService,
} from '@app/core/services';
import { ToastrService } from 'ngx-toastr';
declare var gtag;
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-play-playlist',
  templateUrl: './play-playlist.component.html',
  styleUrls: ['./play-playlist.component.scss'],
})
export class PlayPlaylistComponent implements OnInit, OnDestroy {
  @ViewChild('playlist', { static: true }) private playlistElem;
  @ViewChild('confirmation', { static: true }) private confirmationModal;
  @ViewChild('goldcontent', { static: true }) private goldModal;
  @ViewChild('snap', { static: true }) private snapModal;
  @ViewChild('showcase', { static: true }) private showcaseModal;
  @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  PAGE_SIZE = 10;
  recording;
  comments = [];
  commentsTotal = 0;
  recordingId: any;
  reactionList = [];
  reactions = [];
  favoriting = null;
  showReplay = false;
  currentCommentPage = 1;
  loadingComments = true;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  lastPage = 1;
  channel = null;
  playlistId = null;
  shuffle = false;
  continuousPlay = false;
  ids = [];
  current = 0;
  autoPlayed = 0;
  commentFocus = false;
  totalRecordings = 0;
  isCollapsed = false;
  showJumpButton = false;
  jumpArrowDirection = '⬆';

  recordings = {
    items: [],
    currentPage: 1,     // ✅ FIXED NAME
    isLastPage: false,  // renamed from loadedAll → matches your songsData
    loading: false,
    pageCache: {}       // for caching pages
  };

  recordingsLayers = {
    items: [],
    current: 1,
    loadedAll: false,
    loading: false,
  };
  recordingLayersAll: any;
  backlink;
  firstPlay = true;
  loggedInIsGold = true;
  @ViewChild('listenReaction') listenReaction: ReactionComponent;

  private favoriteSource = new Subject<any>();
  favorite$ = this.favoriteSource.asObservable();

  constructor(
    private recordingService: RecordingService,
    private playlistService: PlaylistService,
    public profileService: ProfileService,
    private usersService: UsersService,
    private utilService: UtilService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private toastService: ToastrService,
    private events: EventService,
    private helpers: HelperService,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.playlistId = params.id;
      console.log('loading recordings')
      this.loadRecordings();
    });
    this.activatedRoute.queryParams.subscribe(queryParams => {
      if (queryParams['backToContest']) {
        this.backlink = '/d/contests/' + queryParams['backToContest'];
      }
    });
  }

  public navigate(commands: any[]): void {
    this.ngZone.run(() => this.router.navigate(commands)).then();
  }


  ngOnInit() {
    this.getRecordingCount(this.playlistId);
    let loggedIn = this.utilService.getloggedUserData();
    this.loggedInIsGold = loggedIn.gold;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
      if (this.commentFocus) return;
      const tag = (event.target as HTMLElement).tagName.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') return;

      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp' ) {
        event.preventDefault();
        this.onPrev();
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown' ) {
        event.preventDefault();
        this.onNext(true);
      }
  }

loadRecordings() {
  // Prevent loading if already on last page or currently loading
  if (this.recordings.isLastPage || this.recordings.loading) {
    return;
  }

  this.recordings.loading = true;

  this.playlistService
    .getPlaylistRecordings(
      this.playlistId,
      this.recordings.currentPage,
      this.PAGE_SIZE
    )
    .subscribe(result => {

      const items = result.data;

      // Check if we've loaded all songs based on totalRecordings
      const currentLoadedCount = this.recordings.items.length;
      const willExceedTotal = currentLoadedCount + items.length > this.totalRecordings;

      // Only take songs up to the total count
      const itemsToAdd = willExceedTotal
        ? items.slice(0, this.totalRecordings - currentLoadedCount)
        : items;

      // Save this page into cache
      this.recordings.pageCache[this.recordings.currentPage] = itemsToAdd;

      // Check if this is the first load
      const isFirstLoad = this.recordings.currentPage === 1 && this.firstPlay;

      // Append new items instead of replacing
      if (isFirstLoad) {
        this.recordings.items = itemsToAdd;
      } else {
        this.recordings.items = [...this.recordings.items, ...itemsToAdd];
      }

      this.recordings.currentPage++;

      // Detect last page - either from API or if we hit total count
      this.recordings.isLastPage = !result.next_page_url || this.recordings.items.length >= this.totalRecordings;

      // Refresh IDs for player
      this.refreshIds();

      // Auto-play first item on very first load only
      if (isFirstLoad && itemsToAdd.length > 0) {
        this.onPlayRecording(itemsToAdd[0], 0);
        this.firstPlay = false;
      }

      // INCREMENT PAGE for next load (but not on first load or if we're done)
      // if (!this.recordings.isLastPage && !isFirstLoad) {
      //   this.recordings.currentPage++;
      // }

    this.logDebug('page');

      this.recordings.loading = false;
      this.detectChanges();

      // ⚡ Scroll back to current playing song after loading more
      if (!isFirstLoad) {
        this.scrollToCurrentSong();
      }
    });
}

  onScrolled(index: number) {
    setTimeout(() => {
      const distanceFromCurrent = Math.abs(index - this.current);
      const isNearEnd = index >= this.recordings.items.length - 3;
      this.showJumpButton = distanceFromCurrent > 1 && !isNearEnd;
      this.jumpArrowDirection = index < this.current ? '⬇' : '⬆';
    }, 300);

    // load more logic stays outside the timeout
    const threshold = Math.max(this.recordings.items.length - 5, 0);
    if (index >= threshold && !this.recordings.loading && !this.recordings.isLastPage) {
      this.loadRecordings();
    }
  }

  trackByRecordingId(index: number, item: any): any {
    return item.id || index;
  }

  getRecordingLayers(id) {
    this.recordingsLayers = {
      items: [],
      current: 1,
      loadedAll: false,
      loading: false,
    };
    this.recordingService.getRecordingLayers(id).subscribe(result => {
      this.recordingsLayers.items.push(...result.data);
    });
  }


  handleSing(song) {
    if (song.gold && !this.profileService.user.gold) {
      this.goldModal.open();
      return;
    }
    this.router.navigate(['/recorder', song.id]);
  }

  handleDuet(duet) {
    if (duet.song.gold && !this.profileService.user.gold) {
      this.goldModal.open();
      return;
    }
    this.router.navigate(['/duet-recorder', duet.id]);
  }

  handleRecordingChange() {
    console.log('handle recording change')
    // this.channel = this.pusherService.pusher.subscribe(
    //   'private-recording-' + this.recordingId
    // );
    // this.channel.bind('pusher:subscription_succeeded', function() {});
    // this.channel.bind('new-message', function(data) {});

    this.getComments();
    this.getRecording();

    this.favorite$.pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(({ success, model, message }) => {
        this.favoriting = null;
        if (success === 'true') {
          this.recording.favorited = !this.recording.favorited;
          this.recording.love_count = model.love_count;
        }
      });
  }

  handleRecordingReaction() {
    if (typeof this.listenReaction != 'undefined') {
      this.listenReaction.emoji$.pipe(
        takeUntil(this.ngUnsubscribe))
        .subscribe(emojiReaction => {
          console.log('reaction', emojiReaction);
          this.recordingService
            .reaction(this.recordingId, emojiReaction.id).pipe(
              takeUntil(this.ngUnsubscribe))
            .subscribe(({ success, reactions }) => {
              if (success) {
                this.reactionList = reactions.concat([]);
                this.reactions = reactions.filter(reaction => {
                  return reaction.count > 0;
                });
                if (this.reactions.length > 1) {
                  this.reactions.sort((a, b) => {
                    return b.count - a.count;
                  });
                }
              }
            });
        });
    }
  }

  getRecording() {
    this.getRecordingLayers(this.recordingId);
    this.recordingService
      .get(this.recordingId).pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe(
        recording => {
          this.reactionList = recording.reactions.concat([]);
          this.reactions = recording.reactions.filter(reaction => {
            return reaction.count > 0;
          });
          if (this.reactions.length > 1) {
            this.reactions.sort((a, b) => {
              return b.count - a.count;
            });
          }
          this.recording = recording;
          this.recording.icons = this.utilService.getRecordingPrivacyIcons(
            recording
          );
          if (this.recording.users) {
            this.recording.users = uniqBy(this.recording.users, 'id');
          }
          setTimeout(() => this.handleRecordingReaction());
          gtag('event', 'listen', {
            action: 'Play Recording Playlist',
            recId: this.recordingId.toString(),
            recSongId: this.recording.song.id.toString(),
            songId: this.recording.song.id.toString()
          });
        },
        err => {
          console.log(err);
          if (err.status === 403) {
            let msg = "Apologies! You are blocked from viewing this user's recordings."
            this.toastService.error(msg
            );
            if (this.current === this.ids.length - 1) {
              console.log('show');
              this.showReplay = true;
            } else {
              this.onNext();
            }
            Bugsnag.notify('Playlist Player error: ' + msg);
          } else {
            let msg = err.toString();
            Bugsnag.notify('Playlist Player error: ' + msg);
          }
        }
      );
  }

  toggleFavorite() {
    this.favoriting = '';
    (this.recording.favorited
      ? this.unFavoriteRecording()
      : this.favoriteRecording()
    ).pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.favoriteSource.next(data);
      });
  }

  favoriteRecording() {
    return this.recordingService.fav(this.recordingId);
  }

  unFavoriteRecording() {
    return this.recordingService.unfav(this.recordingId);
  }

  toggleLove() {
    this.favoriting = true;
    (this.recording.loved ? this.unLoveRecording() : this.loveRecording()).pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.recording.loved = data.model.loved;
        this.recording.stats.love = data.model.stats.love;
        this.favoriting = false;
        if (data.success) {
        }
        // this.onLove.emit({
        //     success: true,
        //     data: data
        // });
      });
  }

  loveRecording() {
    return this.recordingService.love(this.recording.id);
  }

  unLoveRecording() {
    return this.recordingService.unlove(this.recording.id);
  }


  getComments() {
    console.log('getting comments');
    if (this.lastPage >= this.currentCommentPage) {
      this.loadingComments = true;
      this.recordingService
        .getComments(this.recordingId, this.currentCommentPage, 10).pipe(
          takeUntil(this.ngUnsubscribe))
        .subscribe(this.processData.bind(this));
    }
  }

  onEditorFocused(e) {
    this.commentFocus = true;
  }

  onEditorBlurred(e) {
    this.commentFocus = false;
  }

  processData(data) {
    this.currentCommentPage++;
    this.lastPage = data.last_page;
    this.commentsTotal = data.total;

    let newComments = data.data;

    if (this.comments.length > 0) {
      newComments = differenceBy(data.data, this.comments, 'comment_id');
    }
    this.comments = concat(this.comments, newComments);
    this.loadingComments = false;
  }

  getFavoriteTooltip(recording) {
    return recording && recording.favorited
      ? 'Unlove this recording.'
      : 'Love this recording.';
  }

  onLoveHandle($event) {
    this.toggleFavorite();
  }

  refreshIds() {
    this.ids = map(this.recordings.items, 'id');
  }

onPlayRecording(recording, indx = null) {
  console.log('onPlayRecording')
  this.continuousPlay = true;
  this.showJumpButton = false;  // ← hide button immediately on manual selection
  if (indx !== null) {  // ⚡ Changed from 'if (indx)' to handle index 0
    this.current = indx;

    // ⚡ Load more if we're near the end (within last 3 songs) and not on last page
    const nearEnd = this.current >= this.ids.length - 3;
    if (nearEnd && !this.recordings.isLastPage && !this.recordings.loading) {
      this.loadRecordings();
    }
  } else {
    this.current = this.ids.indexOf(recording.id);

    // ⚡ Same check when finding by recording.id
    const nearEnd = this.current >= this.ids.length - 3;
    if (nearEnd && !this.recordings.isLastPage && !this.recordings.loading) {
      this.loadRecordings();
    }
  }
  this.playRecording();
}

  playRecording() {
    console.log('play recording')
    this.logDebug('play');
    this.recordingId = undefined;
    this.recording = null;
    setTimeout(() => {
      this.recordingId = this.recordings.items[this.current].id;
      this.handleRecordingChange();
      // ⚡ Scroll to show current song as second item
      this.scrollToCurrentSong();

    }, 100);

  }

scrollToCurrentSong(force = false) {
  setTimeout(() => {
    if (!this.viewport || this.current < 0) {
      console.log('Viewport not ready or current < 0');
      return;
    }

    if (force) {
      // Force scroll (from button click)
      const targetIndex = Math.max(0, this.current - 1);
      this.viewport.scrollToIndex(targetIndex, 'smooth');
    } else {
      // Auto-scroll only if user is within 10 items of the current playing song
      const currentScrollIndex = this.viewport.measureScrollOffset() / 100; // Adjust to match itemSize
      const distanceFromCurrent = Math.abs(currentScrollIndex - this.current);

      if (distanceFromCurrent <= 10) {
        const targetIndex = Math.max(0, this.current - 1);
        this.viewport.scrollToIndex(targetIndex, 'smooth');
      }
    }
  }, 150);
}

  onShuffle(value) {
    this.shuffle = value;
    if (this.shuffle) {
      const newList = [this.recordings.items[this.current]];
      this.recordings.items.splice(this.current, 1);
      newList.push(...this.utilService.shuffleArray(this.recordings.items));
      this.recordings.items = newList;
      this.refreshIds();
      this.current = 0;
      console.log(this.ids);
    }
  }

  onReplay() {
    this.showReplay = false;
    this.current = 0;
    this.playRecording();
  }

  onPrev() {
    this.continuousPlay = true;
    if (this.current === 0) {
      return;
    }
    this.current--;
    this.playRecording();
  }

  onNext(continuousPlay = true) {
    this.showReplay = false;
    if (this.commentFocus) {
      return;
    }
    this.continuousPlay = continuousPlay;
    if (this.current === this.ids.length - 1) {
      return;
    }

    this.current++;

    // if (this.continuousPlay) {
    //   this.autoPlayed++;
    // } else {
    //   this.autoPlayed = 0;
    // }

    if (this.current === this.ids.length - 1) {
      // this.confirmationModal
      //   .open('CONFIRM', 'Do you want to continue playing the playlist?')
      //   .then(result => {
      //     if (result === 'ok') {
      //       this.autoPlayed = 0;
      //       this.playRecording();
      //     }
      //   });
      this.loadRecordings();
      //  this.autoPlayed = 0;
      this.playRecording();
    } else {
      this.playRecording();
    }
  }

  onAddtoPlaylist() {
    this.playlistElem.open(this.recordingId);
  }

  onRemoveFromPlaylist(pivot_id) {
    this.playlistService.deleteRecordingFromPlaylist(this.playlistId, pivot_id).subscribe(result => {
      this.recordings.items = this.recordings.items.filter(x => x.pivot_id !== pivot_id);
    });
  }

  onProfile(user) {
    this.openLink('/d/profile/' + user.id + '/info');
  }

  openLink(url) {
    window.open(window.location.origin + '/#' + url);
  }

  detectChanges() {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  async subscribeUser(recording) {
    const recordingList = [this.recordings.items];
    this.helpers.subscribeUser(recording, recordingList);
  }

  async unsubscribeUser(recording) {
    const recordingList = [this.recordings.items];
    this.helpers.unsubscribeUser(recording, recordingList);
  }

  openSnapModal() {
    this.snapModal.open(this.recording.users[0]);
  }

  openShowcaseModal() {
    this.showcaseModal.open(this.recording.user);
  }

  sendGift() {
    this.events.onSendGift(this.recording.users[0]);
  }

  sendSnap() {
    this.events.onSendSnapCredit(this.recording.user);
  }

  shareRecording(recording) {
    this.events.onSocialShare({ recording });
  }

  formatViews(views) {

    if (views > 999) {
      views = views / 1000;
      views = views.toFixed(1).replace(/[.,]0$/, "");
      // console.log(views + 'K', "panda");
      return views + 'K';
    } else {
      return views;
    };

  };

  formatLove(love) {
    if (love > 999) {
      love = love / 1000;
      love = love.toFixed(1).replace(/[.,]0$/, "");
      // console.log(love + 'K', "cupid");
      return love + 'K';
    } else {
      return love;
    };
  };

  formatComments(comments) {
    if (comments > 999) {
      comments = comments / 1000;
      comments = comments.toFixed(1).replace(/[.,]0$/, "");
      // console.log(comments + 'K', "cupid");
      return comments + 'K';
    } else {
      return comments;
    };
  };

  selectRecording(item) {
    this.router.navigate(['/d/listen/', item.recording_id]);
  }

  howOthersSingThis(id) {
    this.navigate([`/d/ListenOthersSing/${id}`]);
  }

  navArtistProfile(id) {
    this.navigate([`/d/artists/${id}`])
  }
  getRecordingCount(id) {
    this.playlistService.getPlaylistDetail(id).subscribe(response => {
      this.totalRecordings = response.recordings_count;
    });
  }

  private getNext(dataObj, searchFn) {
    if (dataObj.isLastPage) return;

    const nextPage = dataObj.currentPage + 1;

    // Use cached page
    if (dataObj.pageCache[nextPage]) {
      dataObj.currentPage = nextPage;
      dataObj.items = dataObj.pageCache[nextPage];

      this.recalculateLastPage(dataObj);
      this.detectChanges();
      return;
    }

    // Fetch from server
    dataObj.currentPage = nextPage;
    searchFn();
  }

  private getPrev(dataObj) {
    if (dataObj.currentPage === 1) return;

    const prevPage = dataObj.currentPage - 1;

    dataObj.currentPage = prevPage;
    dataObj.items = dataObj.pageCache[prevPage];

    this.recalculateLastPage(dataObj);
    this.detectChanges();
  }

  private recalculateLastPage(dataObj) {
    const nextPage = dataObj.currentPage + 1;
    dataObj.isLastPage = !dataObj.pageCache[nextPage];
  }

  private scrollToTop() {
    const container = document.getElementById('searchOverlayContainer');
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  getNextSongs() {
    this.getNext(this.recordings, () => this.loadRecordings());
    this.scrollToTop();
  }

  getPrevSongs() {
    this.getPrev(this.recordings);
    this.scrollToTop();
  }

  private logDebug(type) {
    console.log('%c🎵 Playlist Debug - ' + type, 'color:#0f0; font-weight:bold; background:#000; padding:2px 6px;', {
      currentPage: this.recordings.currentPage - 1,
      pagesLoaded: Object.keys(this.recordings.pageCache).map(Number).sort((a,b) => a-b),
      pageSizes: Object.fromEntries(
        Object.entries(this.recordings.pageCache).map(([k,v]) => [k, (v as any[]).length])
      ),
      itemsLoaded: this.recordings.items.length,
      totalRecordings: this.totalRecordings,
      remaining: this.totalRecordings - this.recordings.items.length,
      loadedRecordingIds: this.recordings.items.map(r => r.id),
      isLastPage: this.recordings.isLastPage,
      loading: this.recordings.loading,
      firstPlay: this.firstPlay,
      currentSongIndex: this.current + 1,
      currentRecordingId: this.recordings.items[this.current]?.id ?? null,
      idsLength: this.ids.length,
      idCountMatchesItems: this.ids.length === this.recordings.items.length,
      showJumpBtn: this.showJumpButton,
      at: new Date().toISOString(),
    });
    // console.table({
    //   currentPage: this.recordings.currentPage - 1,
    //   itemsLoaded: this.recordings.items.length,
    //   totalRecordings: this.totalRecordings,
    //   isLastPage: this.recordings.isLastPage,
    //   firstPlay: this.firstPlay,
    //   currentIndex: this.current + 1,
    //   idsLength: this.ids.length,
    // });
  }

}
